jQuery(function () {
  jQuery("#submit-gezinsbond-form").on("click", (e) => {
    e.preventDefault();
    var form = jQuery("#gezinsbond-form")[0];
    var formData = new FormData(form);
    formData.append("_ajax_nonce", localize._ajax_nonce);
    formData.append("action", "post_gezinsbond_shortcode");

    jQuery.ajax({
      type: "POST",
      url: localize._ajax_url,
      data: formData,
      cache: false,
      processData: false,
      contentType: false,
      success: (res) => {
        if (!res.success) {
          jQuery(form).find(".alert").show();
        } else {
          window.location.replace(res.data.variable);
        }
      },
      error: () => {
        jQuery(form).find(".alert").show();
      },
    });
  });
  jQuery("#submit-discountcode-form").on("click", (e) => {
    e.preventDefault();
    jQuery(form).find(".alert").hide();
    var form = jQuery("#discountcode-form")[0];
    var formData = new FormData(form);
    formData.append("_ajax_nonce", localize._ajax_nonce);
    formData.append("action", "post_discount_shortcode");
    jQuery.ajax({
      type: "POST",
      url: localize._ajax_url,
      data: formData,
      cache: false,
      processData: false,
      contentType: false,
      success: (res) => {
        console.log(res);
        if (!res.success) {
          jQuery(form).find(".alert").show();
        } else {
          window.location.replace(res.data.url);
        }
      },
      error: () => {
        jQuery(form).find(".alert").show();
      },
    });
  });
  jQuery("#submit-ampas-form").on("click", (e) => {
    e.preventDefault();
    var form = jQuery("#ampas-form")[0];
    var formData = new FormData(form);
    formData.append("_ajax_nonce", localize._ajax_nonce);
    formData.append("action", "post_ampas_shortcode");

    jQuery.ajax({
      type: "POST",
      url: localize._ajax_url,
      data: formData,
      cache: false,
      processData: false,
      contentType: false,
      success: (res) => {
        console.log(res);
        if (!res.success) {
          jQuery(form).find(".alert").show();
        } else {
          window.location.replace(res.data.variable);
        }
      },
      error: () => {
        jQuery(form).find(".alert").show();
      },
    });
  });
  // global validate code
  jQuery(".validate-code").on("submit", (e) => {
    e.preventDefault();
    var form = e.target;
    var submitButton = form.querySelector('button[type="submit"]');
    submitButton.setAttribute("disabled", "disabled");
    var formData = new FormData(form);
    formData.append("_ajax_nonce", localize._ajax_nonce);

    jQuery.ajax({
      type: "POST",
      url: localize._ajax_url,
      data: formData,
      cache: false,
      processData: false,
      contentType: false,
      success: (res) => {
        if (!res.success) {
          jQuery(form).find(".alert").show();
        } else {
          console.log(res.data.variable);
          window.location.replace(res.data.url);
        }
      },
      error: () => {
        jQuery(form).find(".alert").show();
      },
      complete: () => {
        submitButton.removeAttribute("disabled");
      },
    });
  });
});
